export const Logo = () => {
  return (
    <svg
      width="182"
      height="51"
      viewBox="0 0 182 51"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Timely</title>
      <g clipPath="url(#clip0_8595_43512)">
        <mask
          id="mask0_8595_43512"
          className="_lum"
          maskUnits="userSpaceOnUse"
          x="40"
          y="7"
          width="139"
          height="45"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M62.4743 11.8057C62.4743 14.4137 64.4989 16.5279 66.9964 16.5279C69.4939 16.5279 71.5186 14.4137 71.5186 11.8057C71.5186 9.19754 69.4939 7.08331 66.9964 7.08331C64.4989 7.08331 62.4743 9.19754 62.4743 11.8057ZM141.232 7.32262V7.41819C143.41 8.51816 143.966 9.42688 143.966 12.6312V42.3594H154.096V42.2694C152.186 40.9907 152.054 40.327 152.054 37.2419V7.32262H141.232ZM53.6202 8.1841C52.2725 12.9916 49.2759 17.7271 42.2697 18.8037C41.7922 18.8771 41.2427 18.925 40.6211 18.9472V20.4312L42.9425 20.4194H46.5338L46.4445 35.3647L46.445 35.3273C46.4467 35.1696 46.4499 34.9342 46.4547 34.9335C46.5371 41.1148 49.9286 43 54.1316 43C57.082 43 59.6577 40.9756 60.0248 38.6233C60.0328 38.5715 59.6444 38.5166 59.6577 38.4691C59.2859 39.2468 58.377 39.4773 57.474 39.4773C56.2112 39.4773 54.9472 38.3578 54.9472 36.6414V26.7195H54.95V20.4194H61.2337V18.6821H55.0631L54.95 18.6466V8.1841H53.6202ZM129.159 17.8687C122.298 18.1462 117.287 22.7207 117.287 30.263C117.287 38.0936 122.953 42.6093 129.819 42.6093C135.292 42.6093 139.613 39.6789 141.006 34.5387L140.67 34.3946C139.181 37.373 136.283 38.6701 133.354 38.6701C129.1 38.6701 125.98 35.8281 125.977 30.2307H140.582V30.2246H141.246C141.246 23.0515 138.157 17.8514 129.979 17.8519C129.712 17.8519 129.437 17.8575 129.159 17.8687ZM129.728 19.2016C132.465 19.2016 133.237 23.3264 133.263 28.6362H126.186C126.308 23.0332 127.23 19.2016 129.728 19.2016ZM101.145 20.6473C100.275 21.5531 99.3836 22.9591 99.3365 23.3625C98.9124 19.8471 95.7844 18.1678 92.1278 18.1678C90.002 18.1678 88.1026 18.8018 86.672 20.0382C85.6417 20.9287 84.8316 22.2275 84.4009 23.3625V18.6455H73.4701V18.7409C75.6845 20.0305 75.9672 20.6991 75.9672 23.9469V42.1921H84.4009V28.5321C84.4009 24.2336 85.8613 22.2275 88.0759 22.2275C90.2902 22.2275 90.95 23.9948 90.95 26.1918V42.1919L99.3365 42.1921C99.3678 40.8865 99.3836 39.1832 99.3836 37.0815V28.5321C99.3836 24.2336 100.891 22.2275 103.059 22.2275C105.273 22.2275 105.98 23.9948 105.98 26.1918V42.1774L105.955 42.1921L105.98 42.1923V42.2877L110.675 42.2344L116.604 42.2877V42.1921C114.904 41.0958 114.503 40.481 114.413 38.5586V26.4306C114.413 21.7978 112.199 18.1678 107.111 18.1678C104.565 18.1678 102.638 19.0933 101.145 20.6473ZM171.697 18.5794V18.6751C173.198 19.2491 173.985 20.137 173.985 21.7153C173.985 22.385 173.845 23.1025 173.516 23.9155L172.452 26.6985L169.5 33.795L164.659 23.5057C164.237 22.5969 163.956 21.5926 163.956 20.8273C163.956 19.8708 164.284 19.2968 165.269 18.6751V18.5794H153.351C154.103 20.0462 154.963 21.768 155.933 23.7449L165.598 42.9763C164.744 45.1304 164.016 46.6089 163.413 47.4117C163.48 47.0924 163.515 46.761 163.515 46.4214C163.515 43.8134 161.443 41.6991 158.887 41.6991C156.331 41.6991 154.259 43.8134 154.259 46.4214C154.259 49.0294 156.331 51.1437 158.887 51.1437C158.971 51.1437 159.055 51.1414 159.137 51.137C159.476 51.1295 159.779 51.1037 159.947 51.0859C162.157 50.853 163.869 49.7138 165.105 47.626C165.717 46.5929 166.358 45.1533 166.675 44.4711C166.778 44.2899 166.861 44.1281 166.914 43.9989L168.007 41.3342C168.01 41.328 168.013 41.3217 168.016 41.3154L168.014 41.3165L171.856 31.948L175.778 22.5083C176.56 20.9393 177.504 19.6711 178.734 18.6751V18.5794H171.697ZM62.9391 18.6847V42.2312H67.2537L73.3649 42.2875V42.1919C71.6882 41.0842 71.3055 40.468 71.2235 38.498C71.2166 38.0596 71.2131 37.6005 71.2131 37.1207V18.6847H62.9391Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_8595_43512)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M39.4414 52.3266H179.908V5.89578H39.4414V52.3266Z"
            fill="#F9F7F5"
          />
        </g>
        <mask
          id="mask1_8595_43512"
          className="_lum"
          maskUnits="userSpaceOnUse"
          x="1"
          y="9"
          width="36"
          height="35"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1.41406 27.1769C1.41406 33.7473 5 39.4779 10.3168 42.5092L10.5142 42.263C8.48494 40.0785 7.23772 37.1115 7.23772 33.8434C7.23772 27.1297 12.5014 21.6871 18.9945 21.6871C25.4875 21.6871 30.7512 27.1297 30.7512 33.8434C30.7512 37.1141 29.5019 40.0831 27.47 42.2682L27.6662 42.5127C32.9862 39.4823 36.5748 33.7498 36.5748 27.1769C36.5748 17.4426 28.7038 9.55142 18.9945 9.55142C9.28508 9.55142 1.41406 17.4426 1.41406 27.1769ZM12.2549 36.9252C12.2549 40.7355 15.2722 43.8243 18.9943 43.8243C22.7162 43.8243 25.7336 40.7355 25.7336 36.9252C25.7336 33.115 22.7162 30.0261 18.9943 30.0261C15.2722 30.0261 12.2549 33.115 12.2549 36.9252Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask1_8595_43512)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.226562 45.0072H37.764V8.3624H0.226562V45.0072Z"
            fill="#FF616A"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_8595_43512">
          <rect width="181.333" height="51" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const LogoIcon = (props) => {
  return (
    <svg
      {...props}
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 8C0 3.58172 3.58172 0 8 0H22C26.4183 0 30 3.58172 30 8V22C30 26.4183 26.4183 30 22 30H8C3.58172 30 0 26.4183 0 22V8Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.0011 16.785C15.5008 16.7851 15.9957 16.8806 16.4574 17.0661C16.919 17.2516 17.3385 17.5235 17.6918 17.8663C18.0452 18.209 18.3254 18.6159 18.5166 19.0637C18.7078 19.5115 18.8062 19.9915 18.8062 20.4762C18.8061 20.9609 18.7077 21.4408 18.5164 21.8886C18.3251 22.3363 18.0448 22.7432 17.6914 23.0859C17.338 23.4286 16.9184 23.7004 16.4567 23.8858C15.995 24.0713 15.5002 24.1667 15.0004 24.1666C13.9912 24.1666 13.0233 23.7778 12.3096 23.0856C11.596 22.3935 11.195 21.4547 11.195 20.4758C11.195 19.497 11.596 18.5582 12.3096 17.866C13.0233 17.1739 13.9912 16.785 15.0004 16.785H15.0011ZM15.0011 5.83331C20.4005 5.83331 24.7782 10.0547 24.7782 15.2623C24.7782 18.7787 22.7822 21.8447 19.8233 23.4663L19.7146 23.335C20.8924 22.113 21.5452 20.5012 21.5397 18.8284C21.5397 15.2371 18.6116 12.3256 15.0004 12.3256C11.3892 12.3256 8.46186 15.2371 8.46186 18.8284C8.4563 20.4993 9.10748 22.1094 10.2828 23.331L10.1734 23.4636C7.21733 21.8427 5.22266 18.7767 5.22266 15.2623C5.22266 10.0547 9.6004 5.83331 15.0011 5.83331Z"
        fill="#FF616A"
      />
    </svg>
  );
};

export const LogoDark = (props) => {
  return (
    <svg
      width="128"
      height="36"
      viewBox="0 0 128 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Timely</title>
      <g clipPath="url(#clip0_9011_32711)">
        <mask
          id="mask0_9011_32711"
          className="_lum"
          maskUnits="userSpaceOnUse"
          x="28"
          y="5"
          width="99"
          height="32"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M44.1015 8.33347C44.1015 10.1744 45.5833 11.6668 47.4112 11.6668C49.2391 11.6668 50.721 10.1744 50.721 8.33347C50.721 6.49239 49.2391 5 47.4112 5C45.5833 5 44.1015 6.49239 44.1015 8.33347ZM99.6952 5.16892V5.23638C101.272 6.01283 101.675 6.65428 101.675 8.91618V29.9008H109.011V29.8372C107.628 28.9347 107.532 28.4661 107.532 26.2884V5.16892H99.6952ZM38 5.77703C37.0333 9.17059 34.8839 12.5133 29.8583 13.2732C29.5158 13.325 29.1216 13.3589 28.6758 13.3745V14.422L30.3409 14.4137H32.917L32.8529 24.9633L32.8532 24.9369C32.8545 24.8256 32.8568 24.6595 32.8602 24.659C32.9193 29.0223 35.3521 30.3529 38.3668 30.3529C40.4831 30.3529 42.3307 28.924 42.594 27.2635C42.5998 27.227 42.3211 27.1882 42.3307 27.1546C42.064 27.7036 41.4121 27.8663 40.7644 27.8663C39.8585 27.8663 38.9519 27.0761 38.9519 25.8645V18.8608H38.9539V14.4137H43.4611V13.1874H39.035L38.9539 13.1623V5.77703H38ZM91.2891 12.6132C86.3789 12.8091 82.7923 16.0382 82.7923 21.3621C82.7923 26.8896 86.8472 30.0772 91.7611 30.0772C95.6786 30.0772 98.7712 28.0086 99.7678 24.3803L99.5272 24.2785C98.462 26.381 96.3876 27.2966 94.2914 27.2966C91.2468 27.2966 89.0136 25.2904 89.012 21.3394H99.4649V21.335H99.9396C99.9396 16.2717 97.7291 12.601 91.876 12.6014C91.6846 12.6014 91.4884 12.6053 91.2891 12.6132ZM91.6931 13.5541C93.7154 13.5541 94.2865 16.4657 94.3058 20.2138H89.0744C89.1653 16.2587 89.8465 13.5541 91.6931 13.5541ZM71.5488 14.5746C70.9299 15.2139 70.2957 16.2064 70.2622 16.4912C69.9606 14.0097 67.7355 12.8243 65.1344 12.8243C63.6222 12.8243 62.2712 13.2718 61.2535 14.1446C60.5206 14.7732 59.9443 15.69 59.6379 16.4912V13.1615H51.8624V13.2289C53.4377 14.1392 53.6388 14.6112 53.6388 16.9037V29.7827H59.6379V20.1403C59.6379 17.1061 60.6768 15.69 62.2521 15.69C63.8273 15.69 64.2966 16.9375 64.2966 18.4883V29.7825L70.2622 29.7827C70.2845 28.8611 70.2957 27.6587 70.2957 26.1752V20.1403C70.2957 17.1061 71.3682 15.69 72.9098 15.69C74.485 15.69 74.9877 16.9375 74.9877 18.4883V29.7723L74.9705 29.7827L74.9877 29.7828V29.8501L78.3279 29.8126L82.5449 29.8501V29.7827C81.3361 29.0088 81.0506 28.5749 80.987 27.2179V18.6569C80.987 15.3867 79.4118 12.8243 75.7922 12.8243C73.9813 12.8243 72.6107 13.4777 71.5488 14.5746ZM121.369 13.1149V13.1824C122.443 13.5876 123.006 14.2144 123.006 15.3285C123.006 15.8012 122.905 16.3076 122.67 16.8815L121.909 18.846L119.798 23.8553L116.336 16.5923C116.034 15.9508 115.833 15.2418 115.833 14.7017C115.833 14.0265 116.068 13.6213 116.772 13.1824V13.1149H108.249C108.787 14.1503 109.402 15.3656 110.096 16.7611L117.007 30.3362C116.397 31.8568 115.876 32.9004 115.445 33.4671C115.493 33.2417 115.518 33.0078 115.518 32.7681C115.518 30.9271 114.036 29.4347 112.208 29.4347C110.38 29.4347 108.899 30.9271 108.899 32.7681C108.899 34.609 110.38 36.1015 112.208 36.1015C112.268 36.1015 112.328 36.0998 112.387 36.0967C112.63 36.0914 112.846 36.0732 112.966 36.0606C114.547 35.8962 115.771 35.0921 116.655 33.6184C117.093 32.8891 117.551 31.8729 117.778 31.3914C117.852 31.2635 117.911 31.1492 117.949 31.0581L118.73 29.1771C118.732 29.1727 118.734 29.1683 118.737 29.1639L118.736 29.1646L121.483 22.5516L124.288 15.8882C124.847 14.7807 125.522 13.8855 126.402 13.1824V13.1149H121.369ZM44.4283 13.1892V29.8102H47.5713L52.023 29.85V29.7825C50.8016 29.0006 50.5228 28.5657 50.463 27.1751C50.4581 26.8656 50.4555 26.5416 50.4555 26.2028V13.1892H44.4283Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_9011_32711)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M27.8457 36.9363H127.234V4.16162H27.8457V36.9363Z"
            fill="#323B40"
          />
        </g>
        <mask
          id="mask1_9011_32711"
          className="_lum"
          maskUnits="userSpaceOnUse"
          x="1"
          y="6"
          width="26"
          height="25"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1 19.1837C1 23.8217 3.55525 27.8668 7.34384 30.0065L7.48451 29.8327C6.03853 28.2907 5.14979 26.1964 5.14979 23.8894C5.14979 19.1504 8.90054 15.3085 13.5274 15.3085C18.1541 15.3085 21.9049 19.1504 21.9049 23.8894C21.9049 26.1982 21.0147 28.294 19.5668 29.8364L19.7066 30.0089C23.4975 27.8699 26.0547 23.8234 26.0547 19.1837C26.0547 12.3124 20.446 6.74219 13.5274 6.74219C6.60868 6.74219 1 12.3124 1 19.1837ZM8.65287 26.0649C8.65287 28.7545 10.8354 30.9348 13.5277 30.9348C16.22 30.9348 18.4025 28.7545 18.4025 26.0649C18.4025 23.3753 16.22 21.1949 13.5277 21.1949C10.8354 21.1949 8.65287 23.3753 8.65287 26.0649Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask1_9011_32711)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.162109 31.7698H26.8944V5.90283H0.162109V31.7698Z"
            fill="#FF616A"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_9011_32711">
          <rect width="128" height="36" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
